import { createAction, props } from "@ngrx/store";

export const setMaintenanceTime = createAction(
	"[Maintenance] Set Maintenance Time",
	props<{ maintenanceTime: string }>()
);

export const clearMaintenanceTime = createAction("[Maintenance] Clear Maintenance Time");
